import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome } from "react-icons/fi";
import { T, fmtMYR, fmtCurrency } from "../../_components/Purchasing/PurchaseShared";
import { getIndirectPurchaseInvoices, getIndirectPIKpis, deletePurchaseInvoice } from "../../_services/purchase.service";

export default function IndirectPurchaseInvoices() {
    return (
        <DocList
            docType="Indirect Purchase Invoice"
            basePath="/finance/indirect-purchase-invoices"
            fetchList={getIndirectPurchaseInvoices}
            fetchKpis={getIndirectPIKpis}
            deleteItem={deletePurchaseInvoice}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total IPI", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Company Name", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiFileText, label: "Inv Reference No", key: "refNo" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v,row) => fmtCurrency(v, row.currency) },
                { icon: FiCreditCard, label: "Payment Terms", key: "paymentTerms" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "IPI No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "supplier", label: "Company Name" },
            ]}
        />
    );
}